exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#mui-overlay{position:fixed;top:0;right:0;bottom:0;left:0;z-index:99999999;background-color:rgba(0,0,0,.2);overflow:auto}:host{display:none}:host([animated]),:host([open]){display:block}:host([animated]) #mui-overlay{height:0%;background-color:#eff0f1}:host([open][animated]) #mui-overlay{height:100%;background-color:rgba(0,0,0,.2);transition:height 0ms,background-color 1s linear}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/sass/mui/overlay.scss
// module id = 38
// module chunks = 0